import { render, staticRenderFns } from "./Form331_v2.vue?vue&type=template&id=c132400a&scoped=true&"
import script from "./Form331_v2.vue?vue&type=script&lang=js&"
export * from "./Form331_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form331_v2.vue?vue&type=style&index=0&id=c132400a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c132400a",
  null
  
)

export default component.exports